import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import simpleBackendRequest from './network/simpleBackendRequest';
import { API_SHORT } from '../constants';
import {
    pbRequestFailure,
    pbRequestStart,
    pbRequestSuccess,
} from './pbRequestSlice';
import { PbRequest } from './pbRequest';
import { PbDispatch } from './index';

export interface LoginManagerActivationStore {
    information: PartnerManagerActivationInformationDto | undefined;
}

export interface PartnerManagerActivationSetPasswordDto {
    token: string;

    password: string;

    tac_accepted: boolean;
}

interface PartnerManagerActivationInformationDto {
    email: string;
    valid_until_timestamp: number;
}

const initialState: LoginManagerActivationStore = {
    information: undefined,
};

const loginManagerActivationSlice = createSlice({
    name: 'loginManagerActivation',
    initialState,
    reducers: {
        setInformation(
            state: LoginManagerActivationStore,
            action: PayloadAction<PartnerManagerActivationInformationDto>
        ) {
            state.information = action.payload;
        },
    },
});

const { setInformation } = loginManagerActivationSlice.actions;

export function GetManagerActivationInformation(token: string) {
    return async (dispatch: PbDispatch) => {
        try {
            dispatch(
                pbRequestStart(PbRequest.GET_MANAGER_ACVIVATION_INFORMATION)
            );
            const request: RequestInit = {};

            const result: Response = await simpleBackendRequest(
                `${API_SHORT}/v3/partners/activation_token?t=${token}`,
                request
            );
            if (result && result.status >= 400) {
                dispatch(
                    pbRequestFailure(
                        PbRequest.GET_MANAGER_ACVIVATION_INFORMATION,
                        ['INVALID_TOKEN']
                    )
                );
            } else {
                const data: PartnerManagerActivationInformationDto =
                    (await result.json()) as PartnerManagerActivationInformationDto;
                dispatch(setInformation(data));
                dispatch(
                    pbRequestSuccess(
                        PbRequest.GET_MANAGER_ACVIVATION_INFORMATION
                    )
                );
            }
        } catch (e) {
            dispatch(
                pbRequestFailure(
                    PbRequest.GET_MANAGER_ACVIVATION_INFORMATION,
                    e?.body?.tags ?? []
                )
            );
        }
    };
}

export function ActivateManagerAndSetPassword(
    activation: PartnerManagerActivationSetPasswordDto,
    callback: (success: boolean) => void
) {
    return async (dispatch: PbDispatch) => {
        try {
            dispatch(
                pbRequestStart(
                    PbRequest.POST_MANAGER_ACTIVATION_AND_SET_PASSWORD
                )
            );
            const request: RequestInit = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(activation),
            };

            const result: Response = await simpleBackendRequest(
                `${API_SHORT}/v3/partners/activation_token`,
                request
            );
            if (result && result.status >= 400) {
                const parsed = await result.json();
                dispatch(
                    pbRequestFailure(
                        PbRequest.POST_MANAGER_ACTIVATION_AND_SET_PASSWORD,
                        parsed.tags ?? []
                    )
                );
                callback(false);
            } else {
                dispatch(
                    pbRequestSuccess(
                        PbRequest.POST_MANAGER_ACTIVATION_AND_SET_PASSWORD
                    )
                );
                callback(true);
            }
        } catch (e) {
            dispatch(
                pbRequestFailure(
                    PbRequest.POST_MANAGER_ACTIVATION_AND_SET_PASSWORD,
                    e?.body?.tags ?? []
                )
            );
        }
    };
}

export default loginManagerActivationSlice.reducer;
